const SET_GLOBAL_STYLES = (state, globalStyles) => {
    state.globalStyles = {
        ...state.globalStyles,
        ...globalStyles
    };
}

export default {
    clearCurrentPageData () {

    },
    setMagicSliderDisplay ( state , flag) {
        state.magicSliderDisplay = flag
    },
    setChangesAreSaved ( state , flag) {
        // console.trace()
        // console.log("setChangesAreSaved: " , flag)
        state.changesAreSaved = flag;
        window.changesAreSaved = flag;
    },
}